import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { currentAuthToken } from '../../../../../core/auth';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../../core/reducers';
import { ConfirmActionDialogComponent } from '../../../../partials/content/crud';

@Component({
  selector: 'kt-user-profile-cropper',
  templateUrl: './user-profile-cropper.component.html',
  styleUrls: ['./user-profile-cropper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class UserProfileCropperComponent implements AfterViewInit {
  croppedImage: any = '';
  imageChangedEvent: any = '';
  files = [];
  base64String: any;
  existImage = '/assets/media/users/blank.jpg';
  private authToken;
  mode = '';
  editable = false;
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<UserProfileCropperComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    if (this.data.existImage) {
      this.existImage = this.data.existImage;
      this.editable = true;
    }
    this.mode = this.data.mode;
  }

  ngAfterViewInit(): void {
    this.toDataURL(this.existImage, (res) => {
      this.base64String = res;
    });
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.loading = true;
  }

  imageLoaded() {
    // show cropper
  }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  save() {
    this.dialogRef.close({ img: this.croppedImage, files: this.files, mode: this.mode });
  }

  imageChanged($event) {
    this.imageChangedEvent = $event;
    this.files = [];
    for (const file of $event.target.files) {
      this.files.push(file);
    }
    this.editable = true;
    this.mode = 'UPDATE';
  }
  toDataURL(url, callback) {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onloadend = () => {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', decodeURIComponent(url));
    xhr.responseType = 'blob';
    xhr.send();
  }
  RemovePicture() {
    const dialogRef = this.dialog.open(ConfirmActionDialogComponent, {
      data: {
        title: 'Remove Profile Picture',
        description: 'Are you sure you want to remove the profile picture?',
        waitDesciption: 'Removing ...',
      },
      width: '440px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }
      this.existImage = '/assets/media/users/blank.jpg';
      this.editable = false;
      this.base64String = this.existImage;
      this.mode = 'DELETE';
      this.cdr.detectChanges();
    });
  }
}
